import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryFeature() {
  const featuredCategories = categories.slice(0, 3);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <span className="text-foreground-500 text-xs font-medium tracking-wider uppercase">
            分类浏览
          </span>
          <h2 className="text-3xl md:text-4xl font-heading text-foreground-950 leading-tight mt-2">
            全网吃瓜
            <br />
            分类直达
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="bg-background-100 rounded-lg p-6 group cursor-pointer hover:bg-background-200/70 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className={`${cat.icon} text-3xl text-foreground-800`}></i>
              </div>
              <h3 className="text-lg font-medium text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}